export class ScrollManager {
  private static instance: ScrollManager
  private callbacks = new Set<(scroller: EventTarget | null) => void>()
  private isListening = false

  static getInstance(): ScrollManager {
    if (!ScrollManager.instance) {
      ScrollManager.instance = new ScrollManager()
    }

    return ScrollManager.instance
  }

  subscribe(callback: (scroller: EventTarget | null) => void): void {
    this.callbacks.add(callback)
    this.startListening()
  }

  unsubscribe(callback: (scroller: EventTarget | null) => void): void {
    this.callbacks.delete(callback)

    if (this.callbacks.size === 0) {
      this.stopListening()
    }
  }

  private startListening(): void {
    if (this.isListening) {
      return
    }

    window.addEventListener('scroll', this.handleScroll, { passive: true, capture: true })
    this.isListening = true
  }

  private stopListening(): void {
    if (!this.isListening) {
      return
    }

    window.removeEventListener('scroll', this.handleScroll, { capture: true })
    this.isListening = false
  }

  private handleScroll = (e: Event): void => {
    this.callbacks.forEach((callback) => callback(e.target))
  }
}
